/* BD HERBS — hero background video.
   The poster image paints first (it is the LCP element). The video source is attached only after the
   page has loaded, and never on phones (under 768px), for reduced motion or with Data Saver. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const saveData = navigator.connection && navigator.connection.saveData;

  const start = (hero) => {
    const video = hero.querySelector('video[data-src-desktop]');
    if (!video || video.dataset.started || reduceMotion.matches || saveData) return;
    if (window.matchMedia('(max-width: 767px)').matches) return;

    const src = video.dataset.srcDesktop;
    if (!src) return;

    video.dataset.started = 'true';
    video.muted = true;
    video.src = src;
    video.addEventListener('playing', () => hero.classList.add('is-playing'), { once: true });
    video.addEventListener(
      'error',
      () => {
        if (video.dataset.srcFallback && video.getAttribute('src') !== video.dataset.srcFallback) {
          video.src = video.dataset.srcFallback;
          video.play().catch(() => {});
        }
      },
      { once: true }
    );
    video.play().catch(() => {});

    // Save battery and data: pause while the hero is scrolled out of view
    new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) video.play().catch(() => {});
      else video.pause();
    }).observe(hero);
  };

  const init = (root) => root.querySelectorAll('.bd-hero').forEach(start);

  if (document.readyState === 'complete') init(document);
  else window.addEventListener('load', () => init(document), { once: true });

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
